import { NoDataCard } from 'modules/campaignAnalytics/components/NoDataCard';
import { NoResult } from 'ui/illustrations';
import { WebLink2 } from 'ui/theme';

type EmptyCardProps = {
  type: 'quick' | 'custom';
};

export const EmptyCard = ({ type }: EmptyCardProps) => {
  return (
    <NoDataCard
      Icon={NoResult}
      title={`Looks like you don't have any ${type} replies`}
      subtitle={
        <>
          <WebLink2 href="#">Click here</WebLink2> for tips on how to drive conversations with
          customers.
        </>
      }
    />
  );
};
